<template lang="pug">
.resume-list
    .labels
        span.labels__label {{ label }}
    .fields(
        v-for='(item, index) in resumeList',
        :key='`${resumeId}-item-${index}`'
    )
        .resume-list__value {{ item?.value || '--' }}
</template>
<script>
export default {
    name: 'ResumeList',
    props: {
        resumeId: {
            type: String,
            required: true
        },
        label: {
            type: String,
            default: ''
        },
        resume: {
            type: Array,
            default: () => []
        }
    },
    computed: {
        resumeList() {
            return this.resume.length > 0 ? this.resume : [{ value: '--' }];
        }
    }
};
</script>

<style lang="scss">
.resume-list {
    display: flex;
    flex-direction: column;
    padding: 0 16px;
    .labels {
        padding: 8px 16px;
        border-bottom: 1px solid $default-border-color;
        &__label {
            color: $primary;
            font-weight: bold;
        }
    }
    .fields {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        padding: 16px;
        border-bottom: 1px solid $default-border-color;
        &:nth-last-child(1) {
            border-bottom: none;
        }
    }
}
</style>
